<template>
    <div>
          
        <div class="container">
            <div class="handle-box" style="overflow-y:hidden;margin-top:-10px">
                <el-input v-model.trim="query.name" placeholder="活码名称" class="handle-input mr10" style="width:150px;"></el-input> 
                <el-input v-model.trim="query.title" placeholder="活码标题" class="handle-input mr10" style="width:150px;"></el-input> 
                <el-select v-model.trim="query.codeType" placeholder="活码分类" class="handle-input mr10" style="width:150px;">
                    <el-option value="" label="全部"  /> 
                    <el-option value="1" label="活码跳链接"  /> 
                    <el-option value="2" label="活码跳图片"  />
                </el-select> 
                <el-button type="success" icon="el-icon-search"    @click="handleSearch">搜索</el-button>
                <el-button type="warning" icon="el-icon-refresh"    @click="refreshSearch">重置</el-button>
                <el-button type="primary"   class="handle-del mr10"  @click="addBind" >新增活码</el-button> 
                                      
            </div>
            <el-table :data="tableData" class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <el-table-column prop="id" label="ID" min-width="65" align="center"></el-table-column>
                <el-table-column prop="name" min-width="120" align="left" label="活码名称"></el-table-column> 
                <el-table-column prop="title" min-width="150" align="left" label="活码标题">
                    <template slot-scope="scope">
                        <p style="font-size:12px">{{scope.row.title}} </p>
                    </template>
                </el-table-column>  
                <el-table-column prop="codeType" width="85" align="left" label="分类">
                    <template slot-scope="scope">
                        <el-tag>{{scope.row.codeType==1?'活码跳链接':scope.row.codeType==2?'活码跳图片':'其他'}} </el-tag>
                    </template>
                </el-table-column> 
                <el-table-column prop="endTime" min-width="200"align="left"   label="信息源"  >
                    <template slot-scope="scope"> 
                        <img v-if="scope.row.codeType==2" :src="scope.row.imgUrl" style="width:50px;" @click="getImgDetail2(scope.row.imgUrl)" />
                        <span v-if="scope.row.codeType==1" style="diaplay:inline-block;font-size:10px;line-height:12px;" type="primary">{{scope.row.link}}</span>
                    </template> 
                </el-table-column>
                <el-table-column prop="channelStatus" width="80" align="center" label="渠道状态">
                      <template slot-scope="scope" >   
                        <el-tooltip :content="scope.row.status=='1'?'活码已开启':'活码已关闭'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template> 
                </el-table-column> 

                <el-table-column prop="endTime" min-width="90"align="center"   label="查看活码"  >
                    <template slot-scope="scope"> 
                        <img  :src="scope.row.codeUrl" style="width:50px;" @click="getImgDetail2(scope.row.codeUrl)"/>
                    
                    </template>  
                </el-table-column> 
                <el-table-column prop="realName" width="70" align="left" label="创建人"></el-table-column>
                <el-table-column prop="createTime"  width="160" align="center"  label="创建时间"  > </el-table-column> 
                <el-table-column label="操作" min-width="210" align="center"  fixed="right">
                    <template slot-scope="scope">
                        <el-button  type="danger" plain  @click="handleDelete(scope.$index, scope.row)" >删除</el-button>
                        <el-button  type="error" plain  @click="handleEdit(scope.$index, scope.row)" >编辑</el-button>
                        <el-button  type="primary" plain  @click="handleDown(scope.$index, scope.row)" >下载</el-button>
                        
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </div>
        <!-- 新建绑定弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增活码"  :append-to-body='true' :key='10086' :visible.sync="addVisible"  width="350px">
            <el-form ref="form" :model="form1" label-width="90px" >
                <el-form-item label="活码名称"  >
                    <el-input v-model.trim="form1.name" placeholder="不超过20个字"></el-input>
                </el-form-item>
                <el-form-item label="活码标题"  >
                    <el-input v-model.trim="form1.title"  placeholder="不超过50个字"></el-input>
                </el-form-item> 
                <el-form-item label="活码类型"  >
                    <el-radio-group v-model.trim="form1.codeType" >
                        <el-radio-button label="1">活码跳链接</el-radio-button> 
                        <el-radio-button label="2">活码跳图片</el-radio-button>  
                    </el-radio-group>
                </el-form-item> 
                <el-form-item label="源链接" v-if="form1.codeType==1" >
                    <el-input v-model.trim="form1.link" ></el-input>
                </el-form-item>
                 
                <el-form-item label="源图片" v-if="form1.codeType==2" > 
                    <div> 
                        <img :src="form1.imgUrl" style="width: 100px;height: 100px;border:1px solid #ddd">
                        <div style="position: relative;width: 100px;height: 100px; margin-top:-112px; border: 1px solid #eee;border-radius: 5px;background-color:#eee;opacity:0;box-sizing: border-box;">
                            <input type="file" name="image" accept="image/*" @change="chageImage" style="position: absolute; width: 97px; height: 97px; cursor: pointer;" />
                        </div>
                    </div> <span style="font-size:12px;display:inline-block;float:left;margin-left:120px;margin-top:-68px;color:#999;"> </span>
                </el-form-item >    
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="addBindSubmit">创建活码</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog :close-on-click-modal="false" title="活码编辑" :modal-append-to-body='false' :visible.sync="editVisible" width="350px">
            <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="活码名称"  >
                    <el-input v-model.trim="form1.name" placeholder="不超过20个字"></el-input>
                </el-form-item>
                <el-form-item label="活码标题"  >
                    <el-input v-model.trim="form1.title"  placeholder="不超过50个字"></el-input>
                </el-form-item> 
                <el-form-item label="活码类型"  >
                    <el-radio-group v-model.trim="form1.codeType" >
                        <el-radio-button label="1">活码跳链接</el-radio-button> 
                        <el-radio-button label="2">活码跳图片</el-radio-button>  
                    </el-radio-group>
                </el-form-item> 
                <el-form-item label="源链接" v-if="form1.codeType==1" >
                    <el-input v-model.trim="form1.link" ></el-input>
                </el-form-item>
                 
                <el-form-item label="源图片" v-if="form1.codeType==2" > 
                    <div> 
                        <img :src="form1.imgUrl" style="width: 100px;height: 100px;border:1px solid #ddd">
                        <div style="position: relative;width: 100px;height: 100px; margin-top:-112px; border: 1px solid #eee;border-radius: 5px;background-color:#eee;opacity:0;box-sizing: border-box;">
                            <input type="file" name="image" accept="image/*" @change="chageImage" style="position: absolute; width: 97px; height: 97px; cursor: pointer;" />
                        </div>
                    </div> <span style="font-size:12px;display:inline-block;float:left;margin-left:120px;margin-top:-68px;color:#999;"> </span>
                </el-form-item >     
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 认</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog :title="form1.stationName+' —— 配置'" :modal-append-to-body='false' :visible.sync="setVisible" width="600px">
            <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="站点类型" >
                    {{form1.stType==0?'系统站':form1.stType==1?'旗舰站':form1.stType==2?'独立站':'品牌站'}}
                </el-form-item> 
                <el-form-item label="短信服务商" >
                        <el-radio-group v-model.trim="form1.smsType" >
                            <el-radio-button label="1">腾讯云短信</el-radio-button>
                            <el-radio-button label="2">阿里云短信</el-radio-button> 
                        </el-radio-group>  
                    </el-form-item>    
                    <el-form-item v-if="form1.smsType==1" label="短信AppId" >
                    <el-input style="" v-model.trim="form1.smsAppId"   placeholder=" " ></el-input>
                    </el-form-item>
                    <el-form-item v-if="form1.smsType==1" label="短信AppKey" >
                    <el-input style="" v-model.trim="form1.smsSecretKey"   placeholder=" " ></el-input>
                    </el-form-item>
                    <el-form-item v-if="form1.smsType==1" label="短信签名" >
                    <el-input style="" v-model.trim="form1.smsSignId"   placeholder=" " ></el-input>
                    </el-form-item>
                    <el-form-item v-if="form1.smsType==1" label="短信模板" >
                    <el-input style="" v-model.trim="form1.smsTemplateId"   placeholder=" " ></el-input>
                    </el-form-item>  
                    <el-form-item v-if="form1.smsType==2" label="短信appid" >
                    <el-input style="" v-model.trim="form1.smsKeyId"   placeholder=" " ></el-input>
                    </el-form-item>
                    <el-form-item v-if="form1.smsType==2" label="短信secret" >
                    <el-input style="" v-model.trim="form1.smsKeySecret"   placeholder=" " ></el-input>
                    </el-form-item>
                    <el-form-item v-if="form1.smsType==2" label="短信签名" >
                    <el-input style="" v-model.trim="form1.smsSignName"   placeholder=" " ></el-input>
                    </el-form-item>
                    <el-form-item v-if="form1.smsType==2" label="短信模板" >
                    <el-input style="" v-model.trim="form1.smsTemplateCode"   placeholder=" " ></el-input>
                    </el-form-item> 
                    <el-form-item label="对象存储ak" >
                    <el-input style="" v-model.trim="form.qiniuAk"   placeholder=" " ></el-input>
                    </el-form-item>
                    <el-form-item label="对象存储sk" >
                    <el-input style="" v-model.trim="form.qiniuSk"   placeholder=" " ></el-input>
                    </el-form-item>
                    <el-form-item label="空间名称" >
                    <el-input style="" v-model.trim="form.qiniuBucketname"   placeholder=" " ></el-input>
                    </el-form-item>
                    <el-form-item label="空间位置" >
                        <el-radio-group v-model.trim="form.qiniuSpacetype" >
                            <el-radio-button label="1">华东</el-radio-button>
                            <el-radio-button label="2">华北</el-radio-button> 
                            <el-radio-button label="3">华南</el-radio-button> 
                        </el-radio-group>   
                    </el-form-item>
                    <el-form-item label="空间域名" >
                    <el-input style="" v-model.trim="form.qiniuDomain"   placeholder=" " ></el-input>
                    </el-form-item> 
                    <el-form-item label="申请提现费率" >
                        <el-input style="width:200px;" v-model.trim="form.cashApplyPercentage" type="number"  placeholder="仅支持两位小数" >%</el-input>
                        %
                    </el-form-item>
                    <el-form-item label="渠道导航链接" >
                        <el-input type="textarea" v-model.trim="form.nav"   placeholder=" " ></el-input>
                    </el-form-item>
             
 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="setVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveSet">确 认</el-button>
            </span>
        </el-dialog>


        <!-- 编辑弹出框 -->
        <el-dialog :title="form3.stationName+' —— 创建失败'" :modal-append-to-body='false' :visible.sync="siteError" width="500px">
            <el-form ref="form" :model="form3" label-width="100px">
                <el-input autosize type="textarea" v-model.trim="form3.fb2" ></el-input>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="siteError = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">再次创建</el-button>
            </span>
        </el-dialog>

        <el-dialog  title="图片" :modal-append-to-body='false' :fullscreen="full" :visible.sync="imgVisible" width="350px" top="80px" height="80%" :before-close="handleClose" >
            <img :src="imgUrl"  style="width:300px" /> 
        </el-dialog>

        <el-dialog  title="图片" :modal-append-to-body='false' :fullscreen="full" :visible.sync="imgVisible2" width="550px" top="50px" height="80%" :before-close="handleClose" >
            <img :src="imgUrl2"  style="width:500px" /> 
        </el-dialog>
    </div>
</template>

<script>
import { fetchData,saveForm,changeForm, deleteById} from '../../api/activeCode'; 
export default {
    name: 'basetable',
    data() {
        return {
            mid:'',
            secret:'',
            stationId:'',
            endTime:'',
            indexUrl:'',
            stationUrl:'',
            bgPhone:'',
            bgPc:'',
            stationLogo:'',
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            }, 
            tableData: [],
            multipleSelection: [],
            delList: [],
            imgUrl:'',
            imgUrl2:'',
            imgVisible:false,
            imgVisible2:false,
            editVisible: false,
            addVisible:false,
            siteError:false,
            setVisible:false,
            pageTotal: 0,
            form1: {codeType:'2',imgUrl:'', },
            form3: {},
            form: {
                shopId: '',
                name: '',
                isShare:'1',
                appletId:'',
                appletName:'',
                phone:'',
            },
            idx: -1,
            id: -1,
            ids:'', 
            pickerOptions: {
                shortcuts: [ {
                    text: '半年后',
                    onClick(picker) { 
                    date.setTime(date.getTime() + 3600 * 1000 * 24 * 365 * 0.5);
                    picker.$emit('pick', date);
                    }
                }, 
                {
                    text: '一年后',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
                    picker.$emit('pick', date);
                    }
                }, 
                {
                    text: '二年后',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24 * 365  * 2);
                    picker.$emit('pick', date);
                    }
                }, 
                {
                    text: '三年后',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24 * 365 * 3);
                    picker.$emit('pick', date);
                    }
                },  
                {
                    text: '一个月体验',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', date);
                    }
                } 
                
                ]
            },
        };
    },
    mounted:function() { 
        this.stationId = localStorage.getItem('ms_stationId');  
        this.mid = localStorage.getItem('ms_mid');  
        this.secret = localStorage.getItem('ms_secret');
        this.query.stationId = this.stationId;   
        this.getData();
    },
    methods: {
        // 获取 数据
        getData() {
            fetchData(this.query).then(res => {
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
      
        //触发重置按钮 
        refreshSearch(){ 
            this.$set(this.query, 'name'); 
            this.$set(this.query, 'title' ); 
            this.$set(this.query, 'codeType' );   
            this.getData();
        }, 
        getImgDetail(val){
            this.imgUrl = val;
            this.imgVisible=true;
        },
        getImgDetail2(val){
            this.imgUrl2 = val;
            this.imgVisible2=true;
        },
        //触发刷新按钮
        refresh(){
            history.go(0); 
        },
        initSite(row){
            this.form3 = row;
            this.siteError = true;
        },
        // 改变状态
        handleStatus(index, row) { 
            row.stationId = this.stationId;
            let tips="";
            if(row.status==1){ 
                tips="开启";
            }else{ 
                tips="关闭";
            }
            changeForm(row).then(res => {
                if(res.code=='200'){
                    this.addVisible = false;
                    this.$message.success(tips+'成功'); 
                    this.getData();
                }else{
                    this.$message.error(tips+res.message); 
                } 
            });
            
           
        },

        handleDown(index,row) {  
            // 创建图片元素 
            var img = new Image();
            //设置图片跨域
            img.setAttribute("crossOrigin", "anonymous");
            //设置图片路径
            img.src = row.codeUrl;
            
            img.onload = function() {
                //创建画布
                var can =  document.createElement("canvas");
                //设置画布大小
                can.width=500;
                can.height = 500;
                let ctx = can.getContext("2d");
                //绘制图片
                ctx.drawImage(img,0,0,500,500);
                //得到图片的base64编码数据
                var newurl = can.toDataURL("image/png"); 
                // 生成一个a元素
                var a = document.createElement("a"); 
                // 创建一个单击事件
                var event = new MouseEvent("click"); 
                // 设置图片名称
                a.download = name || row.name; 
                // 将生成的URL设置为a.href属性
                a.href = newurl; 
                // 触发a的单击事件
                a.dispatchEvent(event); 
            } 
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleDelete(index,row) { 
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {  
                deleteById(row).then(res => {
                    if(res.code=='200'){  
                        this.getData();  
                        this.$message.success(res.message); 
                    }else{
                        this.$message.error(res.message); 
                    }
                });
            })    
        },
         changeFalse(){ 
            //清空多选值
            this.multipleSelection = [];
            //多选框反选
            this.$refs.multipleTable.clearSelection();
        },
        // 新增绑定
        addBind() {   
            this.addVisible = true;
        },
        //主图修改
        chageImage(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            if (!file.type.includes('/png') && !file.type.includes('/jpg') && !file.type.includes('/jpeg') ) {
                 this.$message.error("只能上传png、jpg、jpeg格式的图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => { 
                this.form1.imgUrl = event.target.result;   
            };
            reader.readAsDataURL(file);  
        }, 
        //主图修改
        chageImage2(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }  
            if (!file.type.includes('/png') && !file.type.includes('/jpg') && !file.type.includes('/jpeg') ) {
                 this.$message.error("只能上传png、jpg、jpeg格式的图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => { 
                this.form1.bgPhone = event.target.result;   
            };
            reader.readAsDataURL(file);  
        }, 
        //主图修改
        chageImage3(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            if (!file.type.includes('/png') && !file.type.includes('/jpg') && !file.type.includes('/jpeg') ) {
                 this.$message.error("只能上传png、jpg、jpeg格式的图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => { 
                this.form1.bgPc = event.target.result;   
            };
            reader.readAsDataURL(file);  
        }, 
        //保存新增
        addBindSubmit() { 
            
            this.form1.stationId = this.stationId;
            this.form1.mid = this.mid;
            this.addVisible = false;
            saveForm(this.form1).then(res => {
                if(res.code=='200'){  
                    this.$message.success('添加成功'); 
                    this.getData();
                }else{ 
                    this.addVisible = true;
                    this.$message.error(res.message);
                } 
            });
        },
        // 编辑操作
        handleEdit(index, row) { 
            this.form1 = row;
            this.editVisible = true;
        },
        handleSet(index, row) { 
            this.form1 = row;
            this.setVisible = true;
        },
        // 保存编辑
        saveSet() {  
            this.form1.stationId = this.stationId;
            this.form1.mid = this.mid;
              this.setVisible = false;
            setConfig(this.form1).then(res => {
                if(res.code=='200'){  
                    this.$message.success('配置成功'); 
                    this.getData();
                }else{ 
                    this.setVisible = true;
                    this.$message.error(res.message);
                }  
            });
        },
        // 保存编辑
        saveEdit() {  
            this.form1.stationId = this.stationId;
            this.form1.mid = this.mid;
            changeForm(this.form1).then(res => {
                if(res.code=='200'){ 
                    this.editVisible = false;
                    this.$message.success('编辑成功'); 
                    this.getData();
                }else{ 
                    this.editVisible = true;
                    this.$message.error(res.message);
                }  
            });
        },
        copyVal(text){  
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success("复制成功");  
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData(this.query);
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData(this.query);
        }
    }
};
</script>

<style scoped>
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.handle-del {
    float:right;
    width:80px;
    padding:9px 4px;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
